import {extractModuleIdentifiers, ModuleNode} from '@backstage-components/base';
import {FC} from 'react';
import {TextInputComponent} from '.';
import {ITextInputProps} from './TextInputComponent';
import {SchemaType} from './TextInputDefinition';

export type TextInputProps = SchemaType & ITextInputProps;

export const TextInputPreviewComponent: FC<
  ModuleNode<'TextInput', TextInputProps>
> = (definition) => {
  const {component, props} = definition.module;
  return (
    <TextInputComponent
      component={component}
      config={{scope: 'admin'}}
      {...extractModuleIdentifiers(definition.module)}
      props={props}
    />
  );
};
